import { createSlice} from '@reduxjs/toolkit';
import { apiCallBegan } from './api';
import _ from 'lodash';

const slice = createSlice({
  name: 'admin',
  initialState: {
    airline: '',
    users: [],
    reqStatus: null,
  },
  reducers: {
    setAirline: (state, action) => {
      state.airline = action.payload
    },

    resetReqStatus: (state) => {
      state.reqStatus = null
    },

    adminReqStart: (state) => {
      state.reqStatus = 'loading'
    },

    adminReqSuccess: (state, action) => {
      let users = action.payload
      if (users && Array.isArray(users)) {
        state.users = users;
      }
      state.reqStatus = 'success';
    },

    adminReqError: (state, action) => {
      state.reqStatus = 'failure'
      console.log(`admin req err: ${action.payload}`)
    },

    getUsersSuccess: (state, action) => {
      state.users = action.payload
    },

    getUsersError: (state, action) => {
      console.log(action.payload)
    }
  }
})

const { adminReqStart, adminReqSuccess, adminReqError, getUsersSuccess, getUsersError } = slice.actions
export const { setAirline, resetReqStatus } = slice.actions;

export default slice.reducer;

export const loadUsers = () => (dispatch, getState) => {
  const url = `users/all`

  return dispatch(
    apiCallBegan({
      url,
      method: 'get',
      onSuccess: getUsersSuccess.type,
      onError: getUsersError.type,
    })
  )
}

export const addUser = (user) => (dispatch, getState) => {
  const url = `users`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: user,
      onStart: adminReqStart.type,
      onSuccess: adminReqSuccess.type,
      onError: adminReqError.type,
    })
  )
}

export const editUser = (user) => (dispatch, getState) => {
  const url = `users/edit`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: user,
      onStart: adminReqStart.type,
      onSuccess: adminReqSuccess.type,
      onError: adminReqError.type,
    })
  )
}

export const deleteUser = (user) => (dispatch, getState) => {
  const url = `users/delete`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: user,
      onStart: adminReqStart.type,
      onSuccess: adminReqSuccess.type,
      onError: adminReqError.type,
    })
  )
}